import dayjs from "dayjs";

export default {
  SET_PRODUCT(state, selectedProduct) {
    if (selectedProduct) {
      state.fields.value_old = selectedProduct.promotional_value ? selectedProduct.promotional_value : null;
      state.sales_unit_id = selectedProduct.unit ? selectedProduct.unit.id : null;
      state.fields.integration_code = selectedProduct.integration_code;
      state.product_id = selectedProduct.id;
      state.department_id = selectedProduct.department ? selectedProduct.department.id : null;

      state.fields.brand = selectedProduct.brand || state.fields.brand;
      state.fields.value_wholesale = selectedProduct.value_wholesale || state.fields.value_wholesale;
      state.fields.valid_from = selectedProduct.valid_from || state.fields.valid_from;
      state.fields.valid_until = selectedProduct.valid_until || state.fields.valid_until;
      state.fields.barcode = selectedProduct.barcode || selectedProduct.code;
      state.fields.qr_code = (state.fields.qr_code && state.fields.qr_code.trim()) ? state.fields.qr_code : selectedProduct.code;
      state.fields.custom_qr_code = selectedProduct.custom_qr_code;
      state.fields.old_price = selectedProduct.price;

      if (selectedProduct.value_old) {
        state.fields.value_old = selectedProduct.value_old;
        state.fields.reduced_value = selectedProduct.value_old;
      } else {
        state.fields.value_old = selectedProduct.promotional_value ? selectedProduct.promotional_value : '0,00';
        state.fields.reduced_value = state.fields.old_price;
      }

      state.fields.value_cash = selectedProduct.price;
      state.fields.value_cash2 = selectedProduct.price2;
      state.fields.value_cash3 = selectedProduct.price3;
      state.fields.value_bundle = selectedProduct.value_bundle;
      state.fields.discount_bundle = selectedProduct.discount_bundle;
      state.fields.product_code = selectedProduct.code;
      state.fields.sales_unit = selectedProduct.unit ? selectedProduct.unit.name : null;
      state.fields.sales_unit2 = state.fields.sales_unit;
      state.fields.sales_unit3 = state.fields.sales_unit;
      state.fields.departament = selectedProduct.department ? selectedProduct.department.name : null;
      state.fields.main_description = selectedProduct.main_description;
      state.fields.minor_description = selectedProduct.minor_description;
      state.fields.image = selectedProduct.image;
      state.fields.ibm_code = selectedProduct.ibm_code;
    }
  },

  SET_WITH_DOWN_PAYMENT(state, withDownPayment) {
    state.fields.with_down_payment = withDownPayment;
  },

  SET_PROMOTION_PRODUCT(state, selectedProduct) {
    state.promotion_product_id = selectedProduct.id;

    state.fields.promotion_product = selectedProduct.code;
    state.fields.promotion_main_description = selectedProduct.main_description;
    state.fields.promotion_minor_description = selectedProduct.minor_description;

    state.fields.promotional_product_value = selectedProduct.price;
  },

  SET_UNIT(state, unitSelected) {
    if (unitSelected) {
      state.sales_unit_id = unitSelected.id;
      state.sales_unit2_id = unitSelected.id;
      state.sales_unit3_id = unitSelected.id;
      state.fields.sales_unit = unitSelected.name;
      state.fields.sales_unit2 = unitSelected.name;
      state.fields.sales_unit3 = unitSelected.name;
    }
  },

  SET_DEPARTMENT(state, departmentSelected) {
    if (departmentSelected) {
      state.department_id = departmentSelected.id;
      state.fields.departament = departmentSelected.name;
    }
  },

  SET_FIELD(state, field, value) {
    state.fields[field] = value;
  },

  SET_CONTENT(state, value) {
    state.content = value;
    state.fields.content = value;
  },

  SET_INITIAL_CONTENT(state, value) {
    state.initial_content = value;
  },

  SET_PAYMENT_TYPES(state, value) {
    state.payment_types = value;
  },

  SET_PROPORTIONAL_MEASURES(state, value) {
    state.proportional_measures = value;
  },

  SET_PAYMENT_TYPE_ID(state, value) {
    state.fields.payment_type_id = value;
  },

  SET_SELECTED_TYPE(state, value) {
    state.selected_type = value;
  },

  SET_MAIN_DESCRIPTION(state, value) {
    state.fields.main_description = value;
  },

  SET_MAIN_DESCRIPTION2(state, value) {
    state.fields.main_description2 = value;
  },

  SET_MAIN_DESCRIPTION3(state, value) {
    state.fields.main_description3 = value;
  },

  SET_MINOR_DESCRIPTION(state, value) {
    state.fields.minor_description = value;
  },

  SET_MINOR_DESCRIPTION2(state, value) {
    state.fields.minor_description2 = value;
  },

  SET_MINOR_DESCRIPTION3(state, value) {
    state.fields.minor_description3 = value;
  },

  SET_SIMPLE_DESCRIPTION(state, value) {
    state.fields.simple_description = value;
  },

  SET_SIMPLE_DESCRIPTION2(state, value) {
    state.fields.simple_description2 = value;
  },

  SET_SIMPLE_DESCRIPTION3(state, value) {
    state.fields.simple_description3 = value;
  },

  SET_SIMPLE_DESCRIPTION4(state, value) {
    state.fields.simple_description4 = value;
  },

  SET_SIMPLE_DESCRIPTION5(state, value) {
    state.fields.simple_description5 = value;
  },

  SET_REOPERATED_PRODUCT(state, value) {
    state.fields.reoperated_product = value;
  },

  SET_PRODUCT_OTHER_SIZES(state, value) {
    state.fields.product_other_sizes = value;
  },

  SET_PRODUCT_OTHER_COLORS(state, value) {
    state.fields.product_other_colors = value;
  },

  SET_PRODUCT_COMMENTS(state, value) {
    state.fields.product_comments = value;
  },

  SET_PRODUCT_EVALUATION(state, value) {
    state.fields.product_evaluation = value;
  },

  SET_PRODUCT_MATERIAL(state, value) {
    state.fields.product_material = value;
  },

  SET_PRODUCT_DEPTH(state, value) {
    state.fields.product_depth = value;
  },

  SET_PRODUCT_HEIGHT(state, value) {
    state.fields.product_height = value;
  },

  SET_PRODUCT_WIDTH(state, value) {
    state.fields.product_width = value;
  },

  SET_BRAND(state, value) {
    state.fields.brand = value;
  },

  SET_RETAIL_PACKAGING(state, value) {
    state.fields.retail_packaging = value;
  },

  SET_WHOLESALE_PACKING(state, value) {
    state.fields.wholesale_packing = value;
  },

  SET_BIG_PACKING(state, value) {
    state.fields.big_packing = value;
  },

  SET_VALIDATION(state, value) {
    state.fields.validation = value;
  },

  SET_RETAIL_TAXATION(state, value) {
    state.fields.retail_taxation = value;
  },

  SET_WHOLESALE_TAXATION(state, value) {
    state.fields.wholesale_taxation = value;
  },

  SET_BIG_TAXATION(state, value) {
    state.fields.big_taxation = value;
  },

  SET_LIGHT_TAXATION(state, value) {
    state.fields.light_taxation = value;
  },

  SET_RETAIL_MEDIA(state, value) {
    state.fields.retail_media = value;
  },

  SET_WHOLESALE_MEDIA(state, value) {
    state.fields.wholesale_media = value;
  },

  SET_BIG_MEDIA(state, value) {
    state.fields.big_media = value;
  },

  SET_LIGHT_MEDIA(state, value) {
    state.fields.light_media = value;
  },

  SET_BIG_PRICE(state, value) {
    state.fields.big_price = value;
  },

  SET_LIGHT_PRICE(state, value) {
    state.fields.light_price = value;
  },

  SET_LIGHT_QUANTITY(state, value) {
    state.fields.light_quantity = value;
  },

  SET_FREE_TEXT(state, value) {
    state.fields.free_text = value;
  },

  SET_FREE_TEXT2(state, value) {
    state.fields.free_text2 = value;
  },

  SET_FREE_TEXT3(state, value) {
    state.fields.free_text3 = value;
  },

  SET_CET(state, cet) {
    state.fields.cet = cet;
  },

  SET_CET_PY(state, cet_py) {
    state.fields.cet_py = cet_py;
  },

  SET_DISCOUNT(state, discount) {
    state.fields.discount = discount;
  },

  SET_DISCOUNT_BUNDLE(state, discount_bundle) {
    state.fields.discount_bundle = discount_bundle;
  },

  SET_HAS_INTEREST(state, has_interest) {
    state.fields.has_interest = has_interest;
  },

  SET_LEGAL_INFORMATIONS(state, legal_informations) {
    state.fields.legal_informations = legal_informations;
  },

  SET_PARCEL(state, parcel) {
    parcel = (parcel > 120) ? 120 : parcel;
    state.fields.parcel = parcel;
  },

  SET_PARCEL_SEPARATED_2(state, parcel_separated_2) {
    parcel_separated_2 = (parcel_separated_2 > 120) ? 120 : parcel_separated_2;
    state.fields.parcel_separated_2 = parcel_separated_2;
  },

  SET_EXCLUSIVE_PARCEL(state, exclusive_parcel) {
    exclusive_parcel = (exclusive_parcel > 120) ? 120 : exclusive_parcel;
    state.fields.exclusive_parcel = exclusive_parcel;
  },

  SET_PARCEL_PAID(state, parcel_paid) {
    state.fields.parcel_paid = parcel_paid;
  },

  SET_PARCELED_INTEREST(state, parceled_interest) {
    parceled_interest = (parceled_interest > 120) ? 120 : parceled_interest;
    state.fields.parceled_interest = parceled_interest;
  },

  SET_PARCELED_INTEREST_2(state, parceled_interest_2) {
    parceled_interest_2 = (parceled_interest_2 > 120) ? 120 : parceled_interest_2;
    state.fields.parceled_interest_2 = parceled_interest_2;
  },

  SET_PARCELED(state, parceled) {
    state.fields.parceled = parceled;
  },

  SET_PAYMENT_TYPE(state, payment_type) {
    state.fields.payment_type = payment_type;
  },

  SET_CONDITION(state, condition) {
    state.fields.condition = condition;
  },

  SET_PRODUCT_CODE(state, product_code) {
    state.fields.product_code = product_code;
  },

  SET_PROMOTION_DESCRIPTION(state, promotion_description) {
    state.fields.promotion_description = promotion_description;
  },

  SET_PROMOTION_MAIN_DESCRIPTION(state, promotion_main_description) {
    state.fields.promotion_main_description = promotion_main_description;
  },

  SET_PROMOTION_MINOR_DESCRIPTION(state, promotion_minor_description) {
    state.fields.promotion_minor_description = promotion_minor_description;
  },

  SET_SALES_UNIT_WHOLESALE(state, sales_unit_wholesale) {
    state.fields.sales_unit_wholesale = sales_unit_wholesale;
  },

  SET_PROMOTION_UNIT(state, unitName) {
    state.fields.promotion_unit = unitName;
  },

  SET_PROMOTION_UNIT2(state, unitSelected) {
    state.promotion_unit2_id = unitSelected.id;
    state.fields.promotion_unit2 = unitSelected.name;
  },

  SET_PROMOTIONAL_PRODUCT_VALUE(state, promotional_product_value) {
    state.fields.promotional_product_value = promotional_product_value;
  },

  SET_QUANTITY(state, quantity) {
    state.fields.quantity = quantity;
  },

  SET_QUANTITY2(state, quantity2) {
    state.fields.quantity2 = quantity2;
  },

  SET_QUANTITY3(state, quantity3) {
    state.fields.quantity3 = quantity3;
  },

  SET_RATES_INFO(state, rates_info) {
    state.fields.rates_info = rates_info;
  },

  SET_SALES_UNIT(state, sales_unit) {
    state.fields.sales_unit = sales_unit;
  },

  SET_SALES_UNIT2(state, sales_unit2) {
    state.fields.sales_unit2 = sales_unit2;
  },

  SET_SALES_UNIT3(state, sales_unit3) {
    state.fields.sales_unit3 = sales_unit3;
  },

  SET_SPARE(state, spare) {
    state.fields.spare = spare;
  },

  SET_SPARED_PERCENT(state, spared_percent) {
    state.fields.spared_percent = spared_percent;
  },

  SET_TOTAL_TERM(state, total_term) {
    state.fields.total_term = total_term;
  },

  SET_TOTAL_TERM_2(state, total_term_2) {
    state.fields.total_term_2 = total_term_2;
  },

  SET_VALID_FROM(state, valid_from) {
    state.fields.valid_from = valid_from;
  },

  SET_VALID_UNTIL(state, valid_until) {
    state.fields.valid_until = valid_until;
  },

  SET_VALIDATE(state, validate) {
    state.fields.validate = validate;
  },

  SET_PRODUCT_OLDER(state, product_older) {
    state.fields.product_older = product_older;
  },

  SET_FREE_VALUE(state, free_value) {
    state.fields.free_value = free_value;
  },

  SET_VALUE_CASH(state, value_cash) {
    state.fields.value_cash = value_cash;
  },

  SET_PERCENTAGE_APP(state, percentage_app) {
    state.fields.percentage_app = percentage_app;
  },

  SET_PRICE_APP(state, price_app) {
    state.fields.price_app = price_app;
  },

  SET_LIMIT_APP(state, limit_app) {
    state.fields.limit_app = limit_app;
  },

  SET_PERCENTAGE_CARD(state, percentage_card) {
    state.fields.percentage_card = percentage_card;
  },

  SET_PRICE_CARD(state, price_card) {
    state.fields.price_card = price_card;
  },

  SET_LIMIT_CARD(state, limit_card) {
    state.fields.limit_card = limit_card;
  },

  SET_PARCEL_NUMBER_CARD(state, parcel_number_card) {
    state.fields.parcel_number_card = parcel_number_card;
  },

  SET_PARCEL_PRICE_CARD(state, parcel_price_card) {
    state.fields.parcel_price_card = parcel_price_card;
  },

  SET_MINIMUM_APP(state, minimum_app) {
    state.fields.minimum_app = minimum_app;
  },

  SET_PROPORTIONAL_MEASURE(state, proportional_measure) {
    state.fields.proportional_measure = proportional_measure;
  },

  SET_PROPORTIONAL_QUANTITY(state, proportional_quantity) {
    state.fields.proportional_quantity = proportional_quantity;
  },

  SET_PRODUCT_PROPORTIONAL_VALUE(state, value) {
    state.fields.product_proportional_value = value;
  },

  SET_FROM_WHOLESALE(state, from_wholesale) {
    state.fields.from_wholesale = from_wholesale;
  },

  SET_FROM_LARGE(state, from_large) {
    state.fields.from_large = from_large;
  },

  SET_INPUTS(state, inputs) {
    state.fields.inputs = inputs;
  },

  SET_HAS_WITHOUT_PAYMENT_INITIAL(state, hasWithoutPaymentInitial) {
    state.fields.has_without_payment_initial = hasWithoutPaymentInitial;
  },

  SET_UNIT_PROPORTIONAL(state, unitProportional) {
    state.fields.unit_proportional = unitProportional;
  },

  SET_VALUE_WHOLERETAIL(state, valueWholeretail) {
    state.fields.value_wholeretail = valueWholeretail;
  },

  SET_VALUE_WHOLERETAIL_2(state, valueWholeretail2) {
    state.fields.value_wholeretail_2 = valueWholeretail2;
  },

  SET_VALUE_WHOLERETAIL_3(state, valueWholeretail3) {
    state.fields.value_wholeretail_3 = valueWholeretail3;
  },

  SET_VALUE_WHOLERETAIL_4(state, valueWholeretail4) {
    state.fields.value_wholeretail_4 = valueWholeretail4;
  },

  SET_VALUE_WHOLERETAIL_5(state, valueWholeretail5) {
    state.fields.value_wholeretail_5 = valueWholeretail5;
  },

  SET_PROPORTIONAL_VALUE(state, proportionalValue) {
    state.fields.proportional_value = proportionalValue;
  },

  SET_QUANTITY4(state, quantity4) {
    state.fields.quantity4 = quantity4;
  },

  SET_QUANTITY5(state, quantity5) {
    state.fields.quantity5 = quantity5;
  },

  SET_VALUE_CASH2(state, value_cash2) {
    state.fields.value_cash2 = value_cash2;
  },

  SET_VALUE_CASH3(state, value_cash3) {
    state.fields.value_cash3 = value_cash3;
  },

  SET_VALUE_BUNDLE(state, value_bundle) {
    state.fields.value_bundle = value_bundle;
  },

  SET_VALUE_DIVIDED(state, value_divided) {
    state.fields.value_divided = value_divided;
  },

  SET_REDUCED_VALUE(state, reduced_value) {
    state.fields.reduced_value = reduced_value;
  },

  SET_VALUE_OLD(state, value_old) {
    state.fields.value_old = value_old;
  },

  SET_VALUE_OLD2(state, value_old) {
    state.fields.value_old2 = value_old;
  },

  SET_VALUE_OLD3(state, value_old) {
    state.fields.value_old3 = value_old;
  },

  SET_QR_CODE(state, qrcode) {
    state.fields.qr_code = qrcode;
  },

  SET_CUSTOM_QR_CODE(state, custom_qr_code) {
    state.fields.custom_qr_code = custom_qr_code;
  },

  SET_INSERT_QR_CODE(state, insert_qrcode) {
    state.fields.insert_qrcode = insert_qrcode;
  },

  SET_INSERT_CUSTOM_QR_CODE(state, insert_custom_qrcode) {
    state.fields.insert_custom_qrcode = insert_custom_qrcode;
  },

  SET_BAR_CODE(state, barcode) {
    state.fields.bar_code = barcode;
  },

  SET_IBM_CODE(state, ibm_code) {
    state.fields.ibm_code = ibm_code;
  },

  SET_INSERT_BAR_CODE(state, insert_barcode) {
    state.fields.insert_barcode = insert_barcode;
  },

  SET_VALUE_PLOT_INTEREST(state, value_plot_interest) {
    state.fields.value_plot_interest = value_plot_interest;
  },

  SET_VALUE_PLOT_INTEREST_2(state, value_plot_interest_2) {
    state.fields.value_plot_interest_2 = value_plot_interest_2;
  },

  SET_VALUE_PLOT(state, value_plot) {
    state.fields.value_plot = value_plot;
  },

  SET_VALUE_PLOT_SEPARATED(state, value_plot_separated) {
    state.fields.value_plot_separated = value_plot_separated;
  },

  SET_VALUE_PLOT_SEPARATED_2(state, value_plot_separated_2) {
    state.fields.value_plot_separated_2 = value_plot_separated_2;
  },

  SET_EXCLUSIVE_VALUE_PLOT(state, exclusive_value_plot) {
    state.fields.exclusive_value_plot = exclusive_value_plot;
  },

  SET_UPDATE_PRICE(state, updatePrice) {
    state.update_price = updatePrice;
  },

  SET_VALUE_REMAINING(state, value_remaining) {
    state.fields.value_remaining = value_remaining;
  },

  SET_VALUE_RETAIL(state, value_retail) {
    state.fields.value_retail = value_retail;
  },

  SET_VALUE_SUM(state, value_sum) {
    state.fields.value_sum = value_sum;
  },

  SET_VALUE_TOTAL_WHOLESALE(state, value_total_wholesale) {
    state.fields.value_total_wholesale = value_total_wholesale;
  },

  SET_VALUE_WHOLESALE(state, value_wholesale) {
    state.fields.value_wholesale = value_wholesale;
  },

  SET_VALUE_WHOLESALE_CARD(state, value_wholesale_card) {
    state.fields.value_wholesale_card = value_wholesale_card;
  },

  SET_VALUE_CASH_TAG(state, value_cash_tag) {
    state.fields.value_cash_tag = value_cash_tag;
  },

  SET_INSERT_VALUE_CASH_TAG(state, insert_value_cash_tag) {
    state.fields.insert_value_cash_tag = insert_value_cash_tag;
  },

  SET_FIELD_COMPOUND(state, data) {
    state.fields[data.field] = data.value;
  },

  SET_INSERT_EXPIRATION_DATES(state, value) {
    state.insertExpirationDates = value;
  },

  SET_INSERT_PRODUCT_EXPIRATION_DATES(state, value) {
    state.insertProductExpirationDates = value;
  },

  SET_INSERT_PRODUCT_OLDER(state, value) {
    state.insertProductOlder = value;
  },

  SET_UNITARY_VALUE(state, value) {
    state.fields.unitary_value = value;
  },

  SET_CASHBACK_VALUE(state, value) {
    state.fields.cashback_value = value;
  },

  SET_CASHBACK_VALUE_2(state, value) {
    state.fields.cashback_value_2 = value;
  },

  SET_VALUE_IN_CASH(state, value) {
    state.fields.value_in_cash = value;
  },

  SET_EXCLUSIVE_VALUE_IN_CASH(state, value) {
    state.fields.exclusive_value_in_cash = value;
  },

  SET_EXCLUSIVE_VALUE_CASH(state, value) {
    state.fields.exclusive_value_cash = value;
  },

  SET_TOTAL_VALUE(state, total_value) {
    state.fields.total_value = total_value;
  },

  SET_EXCLUSIVE_PARCEL_2(state, exclusive_parcel_2) {
    exclusive_parcel_2 = (exclusive_parcel_2 > 120) ? 120 : exclusive_parcel_2;
    state.fields.exclusive_parcel_2 = exclusive_parcel_2;
  },

  SET_EXCLUSIVE_VALUE_IN_CASH_2(state, value) {
    state.fields.exclusive_value_in_cash_2 = value;
  },

  SET_EXCLUSIVE_VALUE_CASH_2(state, value) {
    state.fields.exclusive_value_cash_2 = value;
  },

  SET_EXCLUSIVE_VALUE_PLOT_2(state, exclusive_value_plot_2) {
    state.fields.exclusive_value_plot_2 = exclusive_value_plot_2;
  },

  SET_QUANTITY_FRACTIONAL(state, quantity_fractional) {
    state.fields.quantity_fractional = quantity_fractional;
  },

  SET_BASE_VALUE(state, base_value) {
    state.fields.base_value = base_value;
  },

  SET_BASE_TOTAL_VALUE(state, base_total_value) {
    state.fields.base_total_value = base_total_value;
  },

  SET_BASE_PARCEL_QUANTITY(state, base_parcel_quantity) {
    state.fields.base_parcel_quantity = base_parcel_quantity;
  },

  SET_BASE_PARCEL_VALUE(state, base_parcel_value) {
    state.fields.base_parcel_value = base_parcel_value;
  },

  SET_DERIVED_CODE(state, derived_code) {
    state.fields.derived_code = derived_code;
  },

  SET_WARRANTY(state, warranty) {
    state.fields.warranty = warranty;
  },

  SET_ASSEMBLY(state, assembly) {
    state.fields.assembly = assembly;
  },

  SET_ABOUT_PRODUCT(state, about_product) {
    state.fields.about_product = about_product;
  },

  SET_SUPPORTED_WEIGHT(state, supported_weight) {
    state.fields.supported_weight = supported_weight;
  },

  SET_DISCOUNT_FASTSHOP(state, discount_fastshop) {
    state.fields.discount_fastshop = discount_fastshop;
  },

  SET_OFFER_INFORMATION(state, offer_information) {
    state.fields.offer_information = offer_information;
  },

  SET_INSERT_OFFER_INFORMATION(state, insert_offer_information) {
    state.fields.insert_offer_information = insert_offer_information;
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/poster/mutations.js